<template>
  <div class="body">
    <el-link type="primary" class="title" :underline='false'>基础信息</el-link>
    <el-form ref="added" :model="formData" :rules="rules" size="medium" label-position="right" label-width="120px">
     <el-form-item label="活动名称：" prop="name">
        <el-input style="width: 400px;" v-model="formData.name" placeholder="请输入活动名称" :maxlength='30' show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="分类：" prop="type">
        <el-select v-model="formData.type" placeholder="请选择分类" clearable>
          <el-option :label="item.label" :value="item.value" v-for="(item,i) in types" :key="i"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="活动描述：" prop="description">
        <el-input style="width: 400px;" type="text" show-word-limit :maxlength="30"
          @input="formData.description=formData.description.length > 30?formData.description.slice(0, 30):formData.description"
          v-model="formData.description" placeholder="请输入活动描述">
        </el-input>
      </el-form-item>
      <el-form-item label="缩略图：" prop="thumb">
        <el-upload
          class="avatar-uploader"
          action="#"
          :show-file-list="false"
          :on-change="handleAvatarSuccess"
          :limit='1'
          :auto-upload="false"
          :on-error="uploadError"
          >
          <img v-if="formData.thumb" :src="formData.thumb" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <div style="color: #999;">支持JPG/PNG图片格式，文件小于5M</div>
      </el-form-item>
      <el-form-item label="活动时间：" prop="begin_time">
        <el-date-picker
          v-model="value1"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          @change='onchange'
          format='yyyy-MM-dd HH:mm'
          value-format='yyyy-MM-dd HH:mm'
          end-placeholder="结束日期">
        </el-date-picker>
        
      </el-form-item>
      
      <el-form-item label="活动地点：" prop="address">
        <el-input style="width: 400px;" type="text" show-word-limit :maxlength="30"
          @input="formData.address=formData.address.length > 30?formData.address.slice(0, 30):formData.address"
          v-model="formData.address" placeholder="请输入活动地点">
        </el-input>
      </el-form-item>
      <el-form-item label="活动内容：" prop="content" label-width="120px">
        <Editor width='880px' scene_name='activity' v-model='formData.content'></Editor>
      </el-form-item>
      <el-form-item label="报名时间：" prop="enroll_begin_time">
        <el-date-picker
              v-model="value2"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              @change='onchange2'
              format='yyyy-MM-dd HH:mm'
              value-format='yyyy-MM-dd HH:mm'
              end-placeholder="结束日期">
            </el-date-picker>
      </el-form-item>
      <el-form-item label="报名限制人数：" prop="enroll_number_people">
        <el-input style="width: 400px;" type="number" show-word-limit :maxlength="5"
         @input="formData.enroll_number_people=formData.enroll_number_people.length > 5?formData.enroll_number_people.slice(0, 5):formData.enroll_number_people"
         v-model="formData.enroll_number_people" placeholder="请输入报名限制人数">
        </el-input>
      </el-form-item>
    </el-form>
    <el-link type="primary" class="title" :underline='false'>报名配置信息</el-link>
    <Form ref='form' @change="save" :canEdit='!$route.query.id'></Form>
  </div>
</template>

<script>
  import userInfoAPI from '@/api/api';
  import { upload } from '@/api/upload';
  import Editor from '@/components/Editor';
  import Form from './Form.vue';
  export default {
    name: 'userManage',
    components: {
      Editor,
      Form
    },
    data() {
      var validate_enroll_number_people = function(rule, value, callback) {
        if (value === 0 || (value && value < 1)) {
          callback(new Error('报名限制人数不能小于1'))
        } else {
          callback()
        }
      }
      return {
        count: 0,
        title: "", //弹窗title
        dialogVisible: false, //弹窗 ture false
        multipleSelection: [], //是否全选框框
        tableData: [],
        formData: { //弹窗 内容
          name: '',
          type: '',
          description: '',
          thumb: '',
          begin_time: '',
          end_time: '',
          content: '',
          enroll_number_people: '',
          enroll_begin_time: '',
          enroll_end_time: '',
          enroll_config_info: '',
          address: ''
        },
        value1: '',
        value2: '',
        rules: { //弹窗 正则
          name: [{
            required: true,
            message: '请输入活动名称',  
            trigger: 'blur'
          }],
          type: [{
            required: true,
            message: '请选择分类',
            trigger: 'change'
          }],
          thumb: [{
            required: false,
            message: '请输入手机号',
            trigger: 'blur'
          }],
          begin_time: [{
            required: true,
            message: '请选择时间',
            trigger: 'change'
          }],
          content: [{
            required: true,
            message: '请输入内容',
            trigger: 'blur'
          }],
          enroll_begin_time: [{
            required: true,
            message: '请选择报名时间',
            trigger: 'blur'
          }],
          enroll_number_people: [{
            required: false,
            // message: '请输入报名限制人数',
            trigger: 'blur',
            validator: validate_enroll_number_people
          }],
        },
        types: [
          {label: '志愿者招募', value: 'volunteer'},
          {label: '活动中心', value: 'center'}
        ],
        loading: true,
        query: {
          name_or_phone: "",
          page_limit: 10,
          page: 1
        },
        yun76Config: ''
      }
    },
    computed: {
      role_permission() {
        return this.$store.getters.role_permission
      },
      routesData() {
        return this.routes
      }
    },
    created() {
      // userInfoAPI.yun76('activity').then(res=>{
      //   if(res.data.code == 0){
      //     this.yun76Config = res.data.data
      //     this.yun76Config.key = '222'
      //     console.log(this.yun76Config)
      //   }
      // })
      if(this.$route.query.id){
        this.getDetail()
      }
    },
    methods: {
      uploadError(err, file, fileList) {
              this.$message({
                message: "上传出错，请重试！",
                type: "error",
                center: true
              });
            },
      handleAvatarSuccess(file){
        const isIMAGE = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png'
        const isLt5M = file.raw.size / 1024 / 1024 < 5
        if (!isIMAGE) {
          this.$message({
            showClose: true,
            message: '请选择 jpg、png 格式的图片',
            type: 'warning'
          })
          return false
        }
        if (!isLt5M) {
          this.$message({
            showClose: true,
            message: '图片大小不能超过 5MB',
            type: 'warning'
          })
          return false
        }
        upload([file.raw], 'activity').then((urls)=>{
          this.formData.thumb = urls[0]
        })
      },
      onchange(e){
        if(e[0]){
          this.formData.begin_time = e[0]
          this.formData.end_time = e[1]
        }else{
          this.formData.begin_time = ''
          this.formData.end_time = ''
        }
      },
      onchange2(e){
        if(e[0]){
          this.formData.enroll_begin_time = e[0]
          this.formData.enroll_end_time = e[1]
        }else{
          this.formData.enroll_begin_time = ''
          this.formData.enroll_end_time = ''
        }
      },
      JudgeButton(list, rot) {
        let fal = false;
        list.forEach((i, l) => {
          if (i.path == rot) {
            return fal = true;
          }
        })
        return fal
      },
      getDetail() {
        userInfoAPI.getActivityDetail(this.$route.query.id).then(({
          data
        }) => {
          if (data.code == 0) {
            this.value1 = [data.data.begin_time, data.data.end_time]
            this.value2 = [data.data.enroll_begin_time, data.data.enroll_end_time]
            this.formData = data.data
            this.$refs.form.formList = [...this.$refs.form.formList,...data.data.activity_config] 
          } else {
            this.$message({
              showClose: true,
              message: data.msg,
              type: 'error'
            });
          }
          this.loading = false
        })
      },
      save(formList){
        this.$refs['added'].validate(async valid => {
          if (valid) {
            if(this.$route.query.id){
              await userInfoAPI.updateActivity(this.$route.query.id, {
               name: this.formData.name,
               type: this.formData.type,
               description: this.formData.description,
               thumb: this.formData.thumb,
               begin_time: this.formData.begin_time,
               end_time: this.formData.end_time,
               address: this.formData.address,
               content: this.formData.content,
               enroll_begin_time: this.formData.enroll_begin_time,
               enroll_end_time: this.formData.enroll_end_time,
               enroll_number_people: this.formData.enroll_number_people,
              }).then(({
                data
              }) => {
                if (data.code == 0) {
                  this.$message({
                    showClose: true,
                    message: data.msg,
                    type: 'success'
                  })
                  this.$router.back()
                } else {
                  this.$message({
                    showClose: true,
                    message: data.msg,
                    type: 'error'
                  })
                }
              })
            }else{
              this.formData.enroll_config_info = formList
              await userInfoAPI.addActivity(this.formData).then(({
                data
              }) => {
                if (data.code == 0) {
                  this.$message({
                    showClose: true,
                    message: data.msg,
                    type: 'success'
                  })
                  this.value1 = ''
                  this.value2 = ''
                  this.formData =
                   {
                    name: '',
                    type: '',
                    description: '',
                    thumb: '',
                    begin_time: '',
                    end_time: '',
                    content: '',
                    enroll_number_people: '',
                    enroll_begin_time: '',
                    enroll_end_time: '',
                    enroll_config_info: '',
                    address: ''
                  }
                  this.$router.back()
                } else {
                  this.$message({
                    showClose: true,
                    message: data.msg,
                    type: 'error'
                  })
                }
              })
            }
          }
        })
       
      },
      
    }
  }
</script>

<style scoped lang="scss">
  .body{
    padding: 30px;
    .title{
      padding: 20px 0;
      font-size: 18px;
      font-weight: bold;
    }
  }
  /deep/{
    .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }
      .el-upload:hover {
        border-color: #409EFF;
      }
      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
      }
      .avatar {
        width: 178px;
        height: 178px;
        display: block;
      }
  }
  
</style>